'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/21.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderListComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OrderListComponent, _Component);

  function OrderListComponent() {
    (0, _classCallCheck3.default)(this, OrderListComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderListComponent).call(this));
  }

  (0, _createClass3.default)(OrderListComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./OrderListComponent.scss');
      var order = this.props.order;

      var path = '/orderdetail/' + order.grounpid;
      /*
       const orderProductShow = [];
       let productsDetailNum = 0;
       if (orderProductList instanceof Array) {
       orderProductList.forEach((detail, index)=> {
       if (detail.groupID === order.grounpid) {
       orderProductShow.push(
       <li key={index} className={styles.lienewtop}
       style={{border: 'none', marginTop: '10px', background: productsDetailNum % 2 === 0 ? '#f1f1f1' : ''}}>
       <div className={styles.newtoptxt} style={{width: '160px'}}>{detail.name}</div>
       <div className={styles.newtoptxt} style={{width: '160px'}}>{detail.number}</div>
       <div className={styles.newtoptxt} style={{width: '160px'}}>{detail.money}</div>
       <div className={styles.newtoptxt} style={{width: '160px'}}>{detail.packaging}</div>
       <div className={styles.newtoptxt} style={{width: '160px'}}>{detail.service}</div>
       <div className={styles.newtoptxt} style={{width: '160px'}}>{detail.custom}</div>
       </li>
       );
       productsDetailNum = productsDetailNum + 1;
       }
       });
       }*/
      var evaluateDiv = '';
      if (order.status === '订单完成') {
        if (order.isEvaluated === '1') {
          evaluateDiv = _react2.default.createElement(
            _reactRouter.Link,
            { to: '/orderevaluate/' + order.grounpid, className: styles.evaluate },
            '已评价'
          );
        } else if (order.isEvaluated === '0') {
          evaluateDiv = _react2.default.createElement(
            _reactRouter.Link,
            { to: '/orderevaluate/' + order.grounpid, className: styles.evaluate },
            '未评价'
          );
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.pagechildren },
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '230px', textIndent: '10px' } },
            '订单号：',
            order.grounpid
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '200px' } },
            '时间：',
            order.date
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '149px' } },
            '金额：',
            order.money
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '275px' } },
            _react2.default.createElement(
              'span',
              {
                style: { width: 275, overflow: 'hidden', display: 'block', height: '39px', lineHeight: '39px' } },
              '商户：' + order.shop
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.status },
            '状态：',
            order.status
          ),
          evaluateDiv,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: path, className: styles.childb },
            '订单详情'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return OrderListComponent;
}(_react.Component), _class.propTypes = {
  order: _react.PropTypes.object.isRequired
}, _temp);
exports.default = OrderListComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderListComponent/OrderListComponent.js
 ** module id = 1384
 ** module chunks = 0
 **/